import React from 'react'

import { IconProps } from './types'

const CheckCircleSolid = ({ color, size, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM11.8536 5.85355L11.1464 5.14645L7 9.29289L4.85355 7.14645L4.14645 7.85355L7 10.7071L11.8536 5.85355Z"
      fill={color}
    />
  </svg>
)

CheckCircleSolid.displayName = 'CheckCircleSolid'
CheckCircleSolid.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default CheckCircleSolid
